import { render, staticRenderFns } from "./diagnostics.vue?vue&type=template&id=7412c3b6"
import script from "./diagnostics.vue?vue&type=script&lang=js"
export * from "./diagnostics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports